/* =========================================================================
   LMM Leuchtmittel-Finder — Interaktion (Tap/Filter).
   Vanilla, IIFE mit Init-Guard, delegierte document-Listener, data-lmm/data-lf-*.
   Kanonisch: Details per Klick/Tap/Tastatur. Desktop-Hover ist reine CSS-Ergänzung.
   ========================================================================= */
(function () {
  'use strict';
  if (window.__lmmFinderInit) return;
  window.__lmmFinderInit = true;

  var root = document.querySelector('.lf');
  if (!root) return;

  var state = { group: 'alle', query: '' };

  function norm(s) { return (s || '').toLowerCase().replace(/\s+/g, ' ').trim(); }

  function tileMatchesQuery(tile, terms) {
    if (!terms.length) return true;
    var hay = norm(tile.getAttribute('data-keywords') + ' ' +
      (tile.querySelector('.lf-tile__title') ? tile.querySelector('.lf-tile__title').textContent : ''));
    for (var i = 0; i < terms.length; i++) {
      if (hay.indexOf(terms[i]) === -1) return false;
    }
    return true;
  }

  function applyFilter() {
    var sections = root.querySelectorAll('.lf-section[data-group]');
    var terms = state.query ? norm(state.query).split(' ') : [];
    var anyVisible = false;

    sections.forEach(function (section) {
      var groupOk = state.group === 'alle' || section.getAttribute('data-group') === state.group;
      if (!groupOk) { section.style.display = 'none'; return; }

      var tiles = section.querySelectorAll('.lf-tile');
      var visibleInSection = 0;
      tiles.forEach(function (tile) {
        var ok = tileMatchesQuery(tile, terms);
        tile.style.display = ok ? '' : 'none';
        if (ok) visibleInSection++;
      });

      // Abschnitt nur zeigen, wenn (ohne Textfilter) oder mind. 1 Kachel passt
      var show = (terms.length === 0) || visibleInSection > 0;
      section.style.display = show ? '' : 'none';
      if (show && visibleInSection > 0) anyVisible = true;
      if (show && terms.length === 0) anyVisible = true;
    });

    var empty = document.getElementById('lf-empty');
    if (empty) empty.classList.toggle('is-shown', !anyVisible);
  }

  function setGroup(group) {
    state.group = group;
    root.querySelectorAll('[data-lf-group]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', btn.getAttribute('data-lf-group') === group ? 'true' : 'false');
    });
    applyFilter();
  }

  function resetAll() {
    state.query = '';
    var input = document.getElementById('lf-filter-input');
    if (input) input.value = '';
    setGroup('alle');
  }

  // ---- Delegierte Listener ----
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-lf-toggle]');
    if (toggle && root.contains(toggle)) {
      var tile = toggle.closest('.lf-tile');
      if (tile) {
        var open = tile.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      return;
    }

    var chip = e.target.closest('[data-lf-group]');
    if (chip && root.contains(chip)) {
      setGroup(chip.getAttribute('data-lf-group'));
      return;
    }

    var reset = e.target.closest('[data-lf-reset]');
    if (reset && root.contains(reset)) {
      resetAll();
      return;
    }
  });

  document.addEventListener('input', function (e) {
    if (e.target && e.target.id === 'lf-filter-input') {
      state.query = e.target.value || '';
      applyFilter();
    }
  });


  applyFilter();
})();
